import CertificateIssuanceList from "../../features/CertificateIssuance/CertificateIssuanceList";
import "./CertificateIssuance.scss";

const CertificateIssuancePage = () => {
  return (
    <div>
      <CertificateIssuanceList />
    </div>
  );
};

export default CertificateIssuancePage;
